import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';

import { getDevice } from '@/entities/device/services';
import { useGetDeviceQuery, useGetDevicesQuery } from '@/entities/device/hooks';
import { useGetTypesQuery } from '@/entities/type/hooks';

import { Device } from '@/entities/device/types';

import { NkTable, NkTableColumn, NkButton, NkInlineModal, NkGroup } from '@/core/components';
import NkDeviceUpdateForm from '@/entities/device/components/form/DeviceUpdateForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkSubDeviceList',
  props: {
  device: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props



const deviceData = computed(() => ({ id: props.device }));
const hasDeviceData = computed(() => !!deviceData.value.id);
const { data: device } = useGetDeviceQuery(deviceData, { enabled: hasDeviceData });

// Fetching for devices
const hasDevice = computed(() => device.value && 'subDevices' in device.value);
const deviceQueryfilters = computed(() => ({
  ids: [...(device.value?.subDevices || [])],
}));
const { data: devices } = useGetDevicesQuery({
  enabled: hasDevice,
}, deviceQueryfilters);

const { data: types } = useGetTypesQuery();

const subDevices = computed(() => devices.value?.filter(o => device.value?.subDevices.includes(o.id)) || []);
const getSubDevices = computed(() => subDevices.value?.map((o: Device) => ({
  ...o,
  hasChildren: !!o.subDevices.length,
})));

const handleLoad = (row: Device, treeNode: unknown, resolve: (item: Device[]) => void) => {
  const ids: { id: Device['id'] }[] = row.subDevices.map((id) => ({ id }));

  Promise.all(ids.map(id => getDevice(id))).then((_devices: Device[]) => {
    resolve(_devices);
  });
};

const getDeviceName = (_device: Device) => _device.deviceValues.find(o => o.reference === 'name')?.value || '-';
const getDeviceType = (_device: Device) => types.value?.find(type => type.id === _device.type)?.name || '-';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkTable), {
    data: _unref(getSubDevices),
    load: handleLoad,
    "row-key": "id",
    lazy: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkTableColumn), {
        width: "100px",
        label: "ID"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.id), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(NkTableColumn), {
        label: _ctx.$t('misc.name')
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(getDeviceName(scope.row)), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(NkTableColumn), { label: "Type" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(getDeviceType(scope.row)), 1)
        ]),
        _: 1
      }),
      (_ctx.$store.getters['connection/isGranted'](['device_edit']))
        ? (_openBlock(), _createBlock(_unref(NkTableColumn), {
            key: 0,
            width: "200",
            label: "Action"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(NkGroup), null, {
                default: _withCtx(() => [
                  (_ctx.$store.getters['connection/isGranted'](['device_edit']))
                    ? (_openBlock(), _createBlock(_unref(NkInlineModal), {
                        key: 0,
                        title: _ctx.$t('device.action.edit'),
                        class: "max-w-screen-md"
                      }, {
                        content: _withCtx(({close}) => [
                          _createVNode(NkDeviceUpdateForm, {
                            id: scope.row.id,
                            onSubmitted: close
                          }, null, 8, ["id", "onSubmitted"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(NkButton), { icon: "NkPencil" })
                        ]),
                        _: 2
                      }, 1032, ["title"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})